import React, { createRef, useEffect, useMemo, useRef } from 'react' 

import { ContentRight, HeaderContent, ContentRightBody, SendEmailStyles } from './styles'

import { useForm } from 'react-hook-form'
import { PDFDocument } from 'pdf-lib'
import { api } from '../../../services/api'
import Popup from 'reactjs-popup'
import { Row } from '../../../components/commons'
import { useNavigate, useParams } from 'react-router-dom'
import { Document } from '../../../services/documents.service'
import OverlayLoading from '../../../components/OverlayLoading'
import BreadCrumb from './BreadCrumb'
import PageItem from './PageItem'
import FileDetails from '../Documents/FileDetails'
import SelectInput from '../../../components/Input/SelectInput'
import useToast from '../../../hooks/useToast'
import DocumentTypeIndex from './DocumentTypeIndex'
import { ButtonRound } from '../../../components/Header/styles'
import { FaEnvelope, FaMagnifyingGlass, FaPlus, FaTrash } from 'react-icons/fa6'
import { FileStyles } from '../../../components/Modals/ModalUpload/FileUpload/styles'

import { io } from 'socket.io-client'
import InfiniteScroll from 'react-infinite-scroll-component'
import { LoaderComponent } from '../../../components/Table/styles'
import { set } from 'lodash'

const { REACT_APP_SOCKET_URL = '' } = process.env

export interface DocumentsProps {}
interface UserRoleClass {
  _id: string
  name: string
}

export interface FolderItem {
  _id: string
  isFolder: boolean
  name: string
  createdAt: Date
}

type OverLayRef = React.ElementRef<typeof OverlayLoading>
type FileDetailsRef = React.ElementRef<typeof FileDetails>
type DocumentTypeIndexRef = React.ElementRef<typeof DocumentTypeIndex>

const DocumentView: React.FunctionComponent<DocumentsProps> = () => {
  const [documentData, setDocument] = React.useState<Document>()
  const [pdfFileData, setPdfFileData] = React.useState<{originalIndex: number, url: string}[]>([])
  const [documentBlob, setDocumentBlob] = React.useState<any>()

  let chuck: any = useRef([])

  const [isInitialTrigger, setIsInitialTrigger] = React.useState(false)
  const [list, setList] = React.useState(false)
  const modalSideBar = React.useRef<FileDetailsRef>(null)
  const modalDocumentType = React.useRef<DocumentTypeIndexRef>(null)
  const [progress, setProgress] = React.useState(0)
  const [text, settext] = React.useState('Downloading...')

  const [finalizedPages, setFinalizedPages] = React.useState(false)
  const [pagesPdf, setPagesPdf] = React.useState<PDFDocument>()
  const [page, setPage] = React.useState(0)

  let { id } = useParams()

  const fileRefs: any = React.useRef([])
  const loadedPagesCount = React.useRef(0)


  
  const moveLeft = (index: number) => {
    if (index === 0) return;
    setPdfFileData(old => {
      const newArr = [...old];
      const temp = newArr[index - 1];
      newArr[index - 1] = newArr[index];
      newArr[index] = temp;
      return newArr;
    });
  };

  const moveRight = (index: number) => {
    if (index === pdfFileData.length - 1) return;
    setPdfFileData(old => {
      const newArr = [...old];
      const temp = newArr[index + 1];
      newArr[index + 1] = newArr[index];
      newArr[index] = temp;
      return newArr;
    });
  };

  const deletePage = (index: number) => {
    setPdfFileData(old => {
      const newArr = [...old];
      newArr.splice(index, 1);
      return newArr;
    });
  };

  const mappedArray = useMemo(
    () =>
      pdfFileData.map((pageObj, index) => (
        <PageItem 
          key={pageObj.originalIndex} 
          index={index} 
          list={list} 
          page={pageObj} 
          ref={fileRefs.current[pageObj.originalIndex]} 
          onMoveLeft={() => moveLeft(index)}
          onMoveRight={() => moveRight(index)}
          onDelete={() => deletePage(index)}
        />
      )),
    [pdfFileData, list],
  )


  
  const handleSavePdf = async () => {
    try {
      loadingOverlay.current?.handleOpen()
      settext('Gerando PDF...')
      setProgress(50)

      const newPdfDoc = await PDFDocument.create()
      
      const order = pdfFileData.map(p => p.originalIndex)
      
      const totalPages = pagesPdf!.getPages().length;
      for (let i = loadedPagesCount.current; i < totalPages; i++) {
        order.push(i);
      }
      if (order.length === 0) {
         toast.errorToast('O documento não pode ficar vazio!')
         loadingOverlay.current?.handleClose()
         return
      }

      if (!pagesPdf) return;

      const copiedPages = await newPdfDoc.copyPages(pagesPdf, order)
      copiedPages.forEach(p => newPdfDoc.addPage(p))

      const pdfBytes = await newPdfDoc.save()
      const blob = new Blob([pdfBytes], { type: 'application/pdf' })
      const file = new File([blob], documentData?.name || 'documento.pdf', { type: 'application/pdf' })

      const formData = new FormData()
      formData.append('document', file)
      formData.append('action', 'Páginas reordenadas/removidas')

      settext('Salvando nova versão...')
      setProgress(80)

      await api.post(`/documents/${id}/save-version`, formData)
      
      toast.successToast('PDF modificado salvo com sucesso!')
      
      // Redirect to documents
      setTimeout(() => {
        nav('/documents')
      }, 1500)

    } catch (e) {
      console.error(e)
      toast.errorToast('Erro ao salvar PDF')
      loadingOverlay.current?.handleClose()
    }
  }

  const handleSignPdf = async () => {
    try {
      if (!documentBlob) {
        toast.errorToast('Documento ainda não foi carregado.');
        return;
      }
      loadingOverlay.current?.handleOpen();
      settext('Preparando documento para assinatura...');
      setProgress(10);

      // Convert Blob/ArrayBuffer to base64
      const blob = new Blob([documentBlob], { type: 'application/pdf' });
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        try {
          const base64data = (reader.result as string).split(',')[1];
          settext('Aguardando Assinador SERPRO...');
          setProgress(50);
          
          const { signPdfWithSerpro } = await import('../../../services/serpro.service');
          const signedBase64 = await signPdfWithSerpro(base64data);
          
          settext('Enviando documento assinado...');
          setProgress(80);

          // Convert signed base64 back to file
          const byteCharacters = atob(signedBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const signedBlob = new Blob([byteArray], { type: 'application/pdf' });
          const signedFile = new File([signedBlob], documentData?.name || 'documento_assinado.pdf', { type: 'application/pdf' });

          const formData = new FormData();
          formData.append('document', signedFile);
          formData.append('action', 'Assinatura Eletrônica (ICP-Brasil)');

          await api.post(`/documents/${id}/save-version`, formData);
          
          toast.successToast('Documento assinado com sucesso!');
          
          setTimeout(() => {
            nav('/documents');
          }, 1500);

        } catch (err: any) {
          toast.errorToast(err.message || 'Erro ao assinar com SERPRO.');
          loadingOverlay.current?.handleClose();
        }
      };
    } catch (e) {
      console.error(e);
      toast.errorToast('Erro ao assinar documento.');
      loadingOverlay.current?.handleClose();
    }
  }

  const nav = useNavigate()
  const toast = useToast()
  const loadingOverlay = React.useRef<OverLayRef>(null)

  const getDocumentView = async (onlyDoc: boolean = false) => {
    try {
      if (isInitialTrigger) return

      setIsInitialTrigger(true)
      loadingOverlay.current?.handleOpen()

      const { data: response } = await api.get(`/documents/${id}`)
      setDocument(response)

      if (!onlyDoc) {
        // Download via HTTP com onDownloadProgress
        const res = await api.get(`/documents/${id}/download`, {
          responseType: 'arraybuffer',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setProgress(percentCompleted);
            }
          }
        })
        
        const combinedBuffer = res.data
        setDocumentBlob(combinedBuffer)
        extractPDF(combinedBuffer)
      }
    } catch (error) {
      nav('/')
    } finally {
    }
  }

  const fetchDataWithDelay = async (data: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/config/documentConvert', data, {
          responseType: 'arraybuffer',
        })

        const blob = new Blob([res.data], { type: 'image/jpeg' })

        const objectUrl = URL.createObjectURL(blob)

        const originalIndex = data.originalIndex !== undefined ? data.originalIndex : 0;
        setPdfFileData((old) => [...old, { originalIndex, url: objectUrl }]);
        loadedPagesCount.current = Math.max(loadedPagesCount.current, originalIndex + 1);

        fileRefs.current.push(createRef())

        resolve(true)
      } catch (error) {
        reject(false)
        console.error('Error fetching data:', error)
      }
    })
  }

  const generatePdfPages = async (pdf: any, page: any) => {
    setPage(page)

    const size = pdf.getPages().length

    const initialPage = page * 5
    let finalPage = initialPage + 5

    if (finalPage > size) finalPage = size

    if (initialPage > size) {
      setFinalizedPages(true)
      return
    }

    for (let i = initialPage; i < finalPage; i++) {
      const novoPDFDoc = await PDFDocument.create()
      const copiedPages = await novoPDFDoc.copyPages(pdf, [i])
      const [firstPage] = copiedPages

      novoPDFDoc.addPage(firstPage)
      const { width, height } = firstPage.getSize()

      const base64Pdf = await novoPDFDoc.saveAsBase64()

      await fetchDataWithDelay({
        document: base64Pdf,
        name: `${id}-${i}`,
        width: width,
        height: height,
        originalIndex: i
      })
    }
  }

  async function extractPDF(url: any) {
    try {
      settext('Carregando...')
      setProgress(100)

      const pdfDoc = await PDFDocument.load(url, { ignoreEncryption: true })

      loadingOverlay.current?.handleClose()

      setPagesPdf(pdfDoc)
      setPage(pdfDoc.getPages().length)

      generatePdfPages(pdfDoc, 0)
      // Aguarda todas as promessas antes de continuar
    } catch (error) {
      console.log(error)
    }
  }

  const fetchMoreData = () => {
    generatePdfPages(pagesPdf, page + 1)
  }

  const onSelectAllValues = (check: boolean) => {
    fileRefs.current.map((ref: any) => {
      ref?.current.checkValue(check)
    })
  }
  useEffect(() => {
    getDocumentView()
  }, [])

  return (
    <>
      <ContentRight>
        <HeaderContent.Content>
          <BreadCrumb
            list={list}
            openDocumentTypeRef={modalDocumentType}
            onSelectAllValues={onSelectAllValues}
            setList={setList}
            url={documentBlob}
            modalSideBar={modalSideBar}
            documentName={documentData?.name}
            id={id}
            handleSavePdf={handleSavePdf}
            handleSignPdf={handleSignPdf}
            refetch={() => getDocumentView()}
          />
        </HeaderContent.Content>
        <ContentRightBody id='scrollableDiv' isList={!list}>
          <InfiniteScroll
            dataLength={pdfFileData.length}
            next={fetchMoreData}
            hasMore={!finalizedPages}
            loader={<LoaderComponent />}
            scrollableTarget='scrollableDiv'
          >
            {mappedArray}
          </InfiniteScroll>
        </ContentRightBody>
      </ContentRight>
      <OverlayLoading ref={loadingOverlay}>
        <>
          <FileStyles.Title>{text}</FileStyles.Title>
          <FileStyles.Progress>
            <FileStyles.ProgressContent />
            <FileStyles.ProgressBar progress={progress} />
          </FileStyles.Progress>
        </>
      </OverlayLoading>
      <FileDetails ref={modalSideBar} />
      <div id='portalDocumentDetails' />
      <DocumentTypeIndex reflesh={() => getDocumentView(true)} ref={modalDocumentType} />
    </>
  )
}

export default DocumentView

export interface SendEmailProps {
  _id: string
}

export const SendEmail: React.FC<SendEmailProps> = ({ _id }) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const [isLoadingEmail, setIsLoadingEmail] = React.useState(false)
  const [usersFilter, setUsersFilter] = React.useState([])
  const [users, setUsers] = React.useState([])

  const toast = useToast()

  const {
    control,
    getValues,
    reset,
    formState: { errors },
  } = useForm<{
    search: ''
  }>()

  const handleAddUser = async () => {
    const user = getValues('search')

    const userFind: any = usersFilter.find((uservalue: any) => uservalue?._id === user)

    if (userFind) {
      const userAux: any = [...users]
      userAux.push({
        name: userFind?.name,
        _id: userFind._id,
      })
      setUsers(userAux)
    }
    reset()
  }

  const handleSendEmail = async () => {
    try {
      if (!users.length) return toast.errorToast('Adicione pelo menos um usuário')
      setIsLoadingEmail(true)

      await api.post(`/documents/${_id}/sendEmail`, {
        users: users.map((user: any) => user._id),
      })

      reset()
      setUsers([])
      toast.successToast('Arquivo enviado com sucesso!')
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoadingEmail(false)
    }
  }

  const handleRemoveUser = async (index: number) => {
    const usersAux: any = [...users]
    usersAux.splice(index, 1)

    setUsers(usersAux)
  }

  const handleGetUsers = async (search?: string) => {
    try {
      setIsLoading(true)

      const { data: response } = await api.get(`/users`, {
        params: {
          search: search,
        },
      })

      setUsersFilter(response.data)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  React.useEffect(() => {
    handleGetUsers()
  }, [])

  return (
    <>
      <Popup
        trigger={(open) => (
          <ButtonRound
            data-tooltip-id='my-tooltip'
            data-tooltip-content='Enviar documento por e-mail'
            data-tooltip-place='bottom'
          >
            <FaEnvelope color='white' size={15} />
          </ButtonRound>
        )}
        arrow={false}
        position='bottom right'
      >
        <SendEmailStyles.Content>
          <SendEmailStyles.Label>Enviar por E-mail</SendEmailStyles.Label>
          <SendEmailStyles.Row>
            <SelectInput
              error={errors?.search}
              Icon={<FaMagnifyingGlass size={25} />}
              isLoading={isLoading}
              onChangeText={(text) => handleGetUsers(text)}
              options={usersFilter.map((user: any) => ({
                value: user._id,
                label: `${user.name}`,
              }))}
              small
              isClearable
              control={control}
              name='search'
            />

            <ButtonRound onClick={() => handleAddUser()}>
              <FaPlus size={15} color='white' />
            </ButtonRound>
          </SendEmailStyles.Row>
          <SendEmailStyles.Column>
            {users.map((user, index) => (
              <UserEmail key={index} index={index} handleDelete={handleRemoveUser} item={user} />
            ))}
          </SendEmailStyles.Column>
          <SendEmailStyles.Row
            style={{
              justifyContent: 'space-around',
            }}
          >
            <SendEmailStyles.Button
              disabled={isLoadingEmail}
              onClick={() => handleSendEmail()}
              style={{ backgroundColor: '#1a9e04' }}
            >
              <SendEmailStyles.ButtonGreen>Enviar</SendEmailStyles.ButtonGreen>
            </SendEmailStyles.Button>
          </SendEmailStyles.Row>
        </SendEmailStyles.Content>
      </Popup>
    </>
  )
}

const UserEmail = ({
  item,
  index,
  handleDelete,
}: {
  item: UserRoleClass
  index: number
  handleDelete: (index: number) => void
}) => {
  return (
    <>
      <SendEmailStyles.Column>
        <Row gap={10}>
          <SendEmailStyles.Name>{item.name}</SendEmailStyles.Name>

          <ButtonRound onClick={() => handleDelete(index)}>
            <FaTrash size={20} color='white' />
          </ButtonRound>
        </Row>
      </SendEmailStyles.Column>
    </>
  )
}
